function getCookie(name) {
  let cookieArray = document.cookie.split(";");
  for (let i = 0; i < cookieArray.length; i++) {
    let cookiePair = cookieArray[i].trim().split("=");
    if (cookiePair[0] === name) {
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return null;
}

export const fetchDeviceId = () => {
  let deviceId;
  let existingCookieValue = getCookie("browserId");
  if (
    existingCookieValue !== null &&
    existingCookieValue !== undefined &&
    existingCookieValue !== ""
  ) {
    // Cookie with the specified name already exists and has a non-empty value
    deviceId = existingCookieValue;
  } else{
    deviceId = generateDeviceId();
    setSecurePersistentCookie('browserId', deviceId, 365, 'None');
  }
  return deviceId;
};

export function generateDeviceId() {
  const timestamp = new Date().getTime();
  const randomNumber = Math.floor(Math.random() * 1000000);
  const randomString = Math.random().toString(36).substring(2, 8);
  return `${timestamp}${randomNumber}${randomString}`;
}

export function setSecurePersistentCookie(
  name,
  value,
  days,
  samesite = "None"
) {
  let existingCookieValue = getCookie(name);
  if (
    existingCookieValue !== null &&
    existingCookieValue !== undefined &&
    existingCookieValue !== "" &&
    !(name === "campaignId")
  ) {
    // Cookie with the specified name already exists and has a non-empty value
    return;
  }
  let isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";
  if (!isLocalhost && window.location.protocol !== "https:") {
    console.warn(
      "Secure cookies can only be set on HTTPS sites. Cookie was not set."
    );
    return;
  }
  let date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  let expires = "expires=" + date.toUTCString();
  let cookieValue =
    encodeURIComponent(name) +
    "=" +
    encodeURIComponent(value) +
    ";" +
    expires +
    ";path=/";
  if (!isLocalhost) {
    cookieValue += ";secure";
  }
  cookieValue += ";samesite=" + samesite;
  document.cookie = cookieValue;
}
